/* eslint-disable max-len */
import {
  BAM_COMMERCIAL_FAMILY_CODES_DELETE_FILE_URL,
  BAM_COMMERCIAL_FAMILY_CODES_GET_FILE_URL,
  BAM_COMMERCIAL_FAMILY_CODES_UPLOAD_FILE_URL,
} from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { FileUploadRequest } from '@1po/1po-bff-fe-spec/generated/common/file_upload/request/FileUploadRequest';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

export function sendBamCommercialFamilyCodesFileRequest(payload: FileUploadRequest): WebSocketAction {
  return wsSendAction(BAM_COMMERCIAL_FAMILY_CODES_UPLOAD_FILE_URL, payload);
}

export function sendGetBamCommercialFamilyCodesFileRequest(): WebSocketAction {
  return wsSendAction(BAM_COMMERCIAL_FAMILY_CODES_GET_FILE_URL, null);
}

export function sendDeleteBamCommercialFamilyCodesFileRequest(): WebSocketAction {
  return wsSendAction(BAM_COMMERCIAL_FAMILY_CODES_DELETE_FILE_URL, null);
}
